module.exports = __webpack_public_path__ + "static/img/2-fr.98a8ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/2-fr.png
// module id = Qmv/
// module chunks = 1